export { default } from './ESDialog';



// WEBPACK FOOTER //
// ./src/common/ESDialog/index.ts